export default __webpack_public_path__ + "static/media/sacral-chakra.769edd35.png";